(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["localization-form"] && !Shopify.designMode) return;
  try {
    class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        button: this.querySelector('button'),
        panel:  this.querySelector('.dropdown__open_list'),
      };
      if (!this.elements.button || !this.elements.panel) return;

      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
      this.querySelectorAll('.loc-tab').forEach(tab => tab.addEventListener('click', this.onTabClick.bind(this)));
      this._onOutside = this._handleOutside.bind(this);
    }

    /* Chiude se il click/touch è avvenuto fuori dal componente */
    _handleOutside(event) {
      if (!this.contains(event.target)) this.hidePanel();
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', '');
      document.removeEventListener('mousedown',  this._onOutside);
      document.removeEventListener('touchstart', this._onOutside);
    }

    openSelector() {
      const isOpen = !this.elements.panel.hasAttribute('hidden');
      if (isOpen) { this.hidePanel(); return; }

      this.elements.panel.removeAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', 'true');

      /* requestAnimationFrame: aggiunge i listener DOPO che il click corrente è finito,
         così lo stesso tap non chiude subito il pannello che ha appena aperto */
      requestAnimationFrame(() => {
        document.addEventListener('mousedown',  this._onOutside);
        document.addEventListener('touchstart', this._onOutside, { passive: true });
      });
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = event.currentTarget.closest('form');
      if (!form) return;
      const input = form.querySelector('input[name="locale_code"], input[name="country_code"]');
      if (input) input.value = event.currentTarget.dataset.value;
      form.submit();
    }

    onTabClick(event) {
      const tabName = event.currentTarget.dataset.tab;
      this.querySelectorAll('.loc-tab').forEach(tab => {
        const active = tab === event.currentTarget;
        tab.classList.toggle('active', active);
        tab.setAttribute('aria-selected', active.toString());
      });
      this.querySelectorAll('.loc-tab-panel').forEach(panel => {
        panel.toggleAttribute('hidden', panel.dataset.panel !== tabName);
      });
    }
  }

  customElements.define('localization-form', LocalizationForm);
  } catch(e) { console.error(e); }
})();

})();
